/*
 * @Author: Gary
 * @Date: 2017-10-31 11:43:58
 * @Last Modified by: Gary
 * @Last Modified time: 2018-04-09 16:55:24
 * auth
 */

const TokenKey = 'Admin-Token';
const UserInfoKey = 'Admin-User';
const MenuKey = 'Admin-Menu';
const Id = 'Admin-Id';
const MenuIds = 'Admin-menuId';
const SideBarMenu = 'Sider-Menu';
const TopMenu = 'Top-Menu';
const GroupId = 'Group-Id';

export function getSideBarMenu() {
  return JSON.parse(window.sessionStorage.getItem(SideBarMenu))
}

export function setSideBarMenu(sideBarMenu) {
  return window.sessionStorage.setItem(SideBarMenu, JSON.stringify(sideBarMenu))
}

export function getTopMenu() {
  return JSON.parse(window.sessionStorage.getItem(TopMenu))
}
export function setTopMenu(topMenuData) {
  return window.sessionStorage.setItem(TopMenu, JSON.stringify(topMenuData))
}
// 获取topMunu path列表
export function getTopMenuPaths() {
  let list = getTopMenu() || [];
  let menuPaths = [];
  list.forEach(ele => {
    menuPaths.push(ele.path);
    if (ele.dropDown == 1 && ele.subMenu.length > 0) {
      ele.subMenu.forEach(sub => {
        menuPaths.push(ele.path + (sub.path.startsWith('/') ? sub.path : '/' + sub.path));
      });
    }
  });
  return menuPaths;
}
// 页面是否属于pcAdmin菜单
export function isBelongPcAdmin(path) {
  let pathList = getTopMenuPaths();
  if (pathList.includes(path) && path != '/pcAdmin') {
    return false
  } else {
    return true
  }
}

export function getMenuIds() {
  return window.sessionStorage.getItem(MenuIds)
}

export function setMenuIds(menuIds) {
  return window.sessionStorage.setItem(MenuIds, menuIds)
}

export function getId() {
  return window.sessionStorage.getItem(Id)
}

export function setId(id) {
  return window.sessionStorage.setItem(Id, id);
}

export function getToken() {
  return window.sessionStorage.getItem(TokenKey);
}

export function setToken(token) {
  return window.sessionStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return window.sessionStorage.removeItem(TokenKey);
}

export function getUserInfo() {
  return JSON.parse(window.sessionStorage.getItem(UserInfoKey));
}

export function setUserInfo(userInfo) {
  return window.sessionStorage.setItem(UserInfoKey, JSON.stringify(userInfo));
}

export function getMenu() {
  return JSON.parse(window.sessionStorage.getItem(MenuKey));
}

export function setMenu(token) {
  return window.sessionStorage.setItem(MenuKey, JSON.stringify(token));
}

export function setRole(type) {
  return window.sessionStorage.setItem('isAllRole', type);
}

export function removeRole() {
  return window.sessionStorage.removeItem('isAllRole');
}
export function getGroupId() {
  return window.sessionStorage.getItem(GroupId)
}

export function setGroupId(groupId) {
  return window.sessionStorage.setItem(GroupId, groupId);
}
export default {
  getGroupId,
  setGroupId,
  getSideBarMenu,
  setSideBarMenu,
  getTopMenu,
  setTopMenu,
  getTopMenuPaths,
  isBelongPcAdmin,
  getMenuIds,
  setMenuIds,
  getId,
  setId,
  getToken,
  setToken,
  removeToken,
  getUserInfo,
  setUserInfo,
  getMenu,
  setMenu,
  setRole,
  removeRole
}



// WEBPACK FOOTER //
// ./src/utils/auth.js